import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import MoreSuggestionsDropdown from '../MoreSuggestionsDropdown';
import { getCurrentSuggestion, getRandomSuggestion } from '../../../../util';
import s from './CommentSuggestions.scss';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
const CommentSuggestions = ({ suggestions, maxVisible, onSelect })=>{
    const { t } = useTranslation();
    const logBiEvent = useBiLogger();
    const isMounted = useIsMounted();
    // BI receives a stringified array of tuples as the list of suggestions
    const biSuggestionsValue = useMemo(()=>[
            [
                t('commentbox.surpriseMe'),
                1
            ]
        ].concat(suggestions.map((i18nKey, idx)=>{
            const isVisible = idx < maxVisible ? 1 : 0;
            return [
                t(i18nKey),
                isVisible
            ];
        })), [
        t,
        suggestions,
        maxVisible
    ]);
    const commonBiData = useMemo(()=>({
            itemid: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            creatorid: BiContextProvidedValue,
            comment_suggestions: JSON.stringify(biSuggestionsValue)
        }), [
        biSuggestionsValue
    ]);
    const visibleSuggestions = suggestions.slice(0, maxVisible);
    const menuSuggestions = suggestions.slice(maxVisible);
    const menuItems = useMemo(()=>menuSuggestions.map((i18nKey, idx)=>{
            const suggestionText = t(i18nKey);
            return {
                label: `${suggestionText}...`,
                value: `${suggestionText} `,
                biData: BiData(_object_spread_props(_object_spread({
                    evid: 191
                }, commonBiData), {
                    selected_suggestions: suggestionText,
                    rank: maxVisible + idx + 1,
                    is_shown: 0,
                    is_surprise_me: 0
                }))
            };
        }), [
        t,
        menuSuggestions,
        commonBiData,
        maxVisible
    ]);
    useEffect(()=>{
        logBiEvent(BiData(_object_spread({
            evid: 190
        }, commonBiData)), 0.1 // sampled @ 10%
        );
    }, [
        logBiEvent,
        commonBiData
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['suggestions-container']
    }, isMounted && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: cn(s['button'], s['suggestion'], s['random']),
        onClick: ()=>{
            onSelect(getRandomSuggestion(suggestions));
            logBiEvent(BiData(_object_spread_props(_object_spread({
                evid: 191
            }, commonBiData), {
                selected_suggestions: getCurrentSuggestion(),
                rank: 0,
                is_shown: 1,
                is_surprise_me: 1
            })));
        }
    }, t('commentbox.surpriseMe')), visibleSuggestions.map((i18nKey, idx)=>{
        const suggestionText = t(i18nKey);
        return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
            key: `suggestion-${idx}`,
            className: cn(s['button'], s['suggestion']),
            onClick: ()=>onSelect(`${suggestionText} `),
            biData: BiData(_object_spread_props(_object_spread({
                evid: 191
            }, commonBiData), {
                selected_suggestions: suggestionText,
                rank: idx + 1,
                is_shown: 1,
                is_surprise_me: 0
            }))
        }, `${suggestionText}...`);
    }))), isMounted && /*#__PURE__*/ React.createElement(MoreSuggestionsDropdown, {
        items: menuItems,
        commonBiData: commonBiData,
        buttonClassName: s['button'],
        onSelect: onSelect
    }));
};
export default CommentSuggestions;
